module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "ship",
    attrs: {
      "viewBox": "0 0 500 500"
    },
    on: {
      "~click": function($event) {
        _vm.shakeNameplate($event)
      }
    }
  }, [_c('defs', [_c('path', {
    attrs: {
      "id": "window__path",
      "d": "M250,125  a100,100 0 0 0 0,200 a100,100 0 0 0 0, -200z"
    }
  }), _c('path', {
    attrs: {
      "id": "text_f2e__path",
      "d": "\n    M138,220 \n    a110 106 0 1 1 224,0"
    }
  })]), _c('path', {
    staticClass: "wall",
    attrs: {
      "d": "\n          M0,0 h500 v500 h-500z\n          M250,125  a100,100 0 0 0 0,200 a100,100 0 0 0 0, -200z"
    }
  }), _c('g', {
    staticClass: "window_frame"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#window__path"
    }
  })]), _c('g', {
    staticClass: "window_screw"
  }, [_c('use', {
    attrs: {
      "xlink:href": "#window__path"
    }
  })]), _c('text', {
    attrs: {
      "id": "text_f2e",
      "rotate": "0,0,0,0,0,0,0"
    }
  }, [_c('textPath', {
    attrs: {
      "xlink:href": "#text_f2e__path",
      "startOffset": "50%",
      "text-anchor": "middle"
    }
  }, [_vm._v("Front-End Engineer")])]), _c('g', {
    attrs: {
      "id": "g_nameplate"
    }
  }, [_c('rect', {
    staticClass: "nameplate__bg",
    attrs: {
      "x": "200",
      "y": "338",
      "rx": "10",
      "ry": "10",
      "width": "100",
      "height": "28",
      "fill": "orange"
    }
  }), _c('text', {
    staticClass: "text__name",
    attrs: {
      "x": "250",
      "y": "356",
      "text-anchor": "middle"
    }
  }, [_vm._v("Gore Wang")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a27412e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/container/index/components/Cover/svg/ShipWindow/ShipWindow.vue
// module id = 62
// module chunks = 0